var _path, _path2, _path3, _path4, _rect, _mask, _rect2, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinanceBanking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5005 15.5V32.3421",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6997 15.5V32.3421",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2993 15.5V32.3421",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1001 15.5V32.3421",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.50049,
    y: 14.5,
    width: 24,
    height: 18,
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_44981_9418",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.50049,
    y: 31.5,
    width: 34,
    height: 5,
    rx: 1.34737
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.50049,
    y: 31.5,
    width: 34,
    height: 5,
    rx: 1.34737,
    stroke: "#2E2E2E",
    strokeWidth: 4,
    mask: "url(#path-6-inside-1_44981_9418)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50049 11.4583C3.50049 11.3179 3.58499 11.1913 3.71465 11.1375L19.3673 4.63809C19.4526 4.60268 19.5484 4.60268 19.6337 4.63809L20.0172 3.71454L19.6337 4.63809L35.2863 11.1375C35.416 11.1913 35.5005 11.3179 35.5005 11.4583V14.1526C35.5005 14.3445 35.345 14.5 35.1531 14.5H3.84786C3.65601 14.5 3.50049 14.3445 3.50049 14.1526V11.4583Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5005 9.5C20.5005 10.0523 20.0528 10.5 19.5005 10.5C18.9482 10.5 18.5005 10.0523 18.5005 9.5C18.5005 8.94772 18.9482 8.5 19.5005 8.5C20.0528 8.5 20.5005 8.94772 20.5005 9.5Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceBanking);
export default __webpack_public_path__ + "static/media/Finance & Banking.bc3dc92ecdb567ea91af27b1cf5ef0bf.svg";
export { ForwardRef as ReactComponent };